// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

import SvgIconStyle from "../../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  dashboard: getIcon("ic_dashboard"),
  master: getIcon("ic_master"),
  parent: getIcon("ic_parent"),
  report: getIcon("ic_report"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      {
        title: "Rider",
        path: PATH_DASHBOARD.general.addRider,
        icon: ICONS.dashboard,
      },
      {
        title: "Assigned Order for Delivery",
        path: PATH_DASHBOARD.general.order,
        icon: ICONS.dashboard,
      },
    ],
  },
];

export default navConfig;
